import $ from 'jquery';

$(function() {
    $('.btn-download').on('click', function() {
        let a= document.createElement('a');
        a.target= '_blank';
        a.href= $(this).data( "url" );
        a.click();
    });
});
